import ClientesLatitudSur from '../../img/ClientesLatitudSur.png';

const Clientes = () => {
   return (
      <div className="animated fadeIn" id="clientes" style={{ margin: '30px 0' }}>
         <div className="container section">
            <div className="card-panel z-depth-1 white" style={{ borderRadius: '12px', padding: '40px 20px', margin: 0, border: '1px solid #f0f0f0' }}>
               <div className="row" style={{ margin: 0 }}>
                  <div className="col s12 m12 l12 x12 center">
                     <h4 className="black-text text-darken-4" style={{ fontWeight: '700', fontSize: '2rem', marginBottom: '30px' }}>
                        Nuestros Principales Clientes
                     </h4>
                     <img 
                        src={ClientesLatitudSur} 
                        alt="Principales Clientes Latitud Sur" 
                        className="responsive-img" 
                        style={{ maxHeight: '450px', objectFit: 'contain', display: 'block', margin: '0 auto' }} 
                     />
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default Clientes